export async function compressImageToDataUrl(file: File, options?: { maxWidth?: number; quality?: number; mimeType?: string }) {
  const { maxWidth = 1600, quality = 0.8, mimeType } = options || {};
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Failed to read image'));
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(file);
  });

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Failed to load image'));
    image.src = dataUrl;
  });

  const scale = img.width > maxWidth ? maxWidth / img.width : 1;
  const targetWidth = Math.round(img.width * scale);
  const targetHeight = Math.round(img.height * scale);

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return dataUrl; // Fallback to original if no context
  }
  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const outType = mimeType || 'image/jpeg';
  try {
    return canvas.toDataURL(outType, quality);
  } catch {
    return dataUrl; // Fallback to original
  }
}


